// src/components/AdminSettings/tabs/IntegrationsTab.tsx
import React from 'react';
import { IonBadge, IonNote } from '@ionic/react';
import { logoGoogle } from 'ionicons/icons';
import { Card } from '../../ui/Card';
import { Button } from '../../ui/Button';
import { TextInput } from '../../ui/TextInput';
import type { IntegrationsTabProps } from '../types';

export const IntegrationsTab: React.FC<IntegrationsTabProps> = ({
  googleConnected,
  haConnected,
  haUrl,
  haToken,
  haTesting,
  onHaUrlChange,
  onHaTokenChange,
  onConnectGoogle,
  onDisconnectGoogle,
  onTestAndSaveHA,
}) => {
  return (
    <>
      <Card title="Google" style={{ marginBottom: 16 }}>
        <p style={{ color: 'var(--ion-color-medium)', marginBottom: 12 }}>
          Connect Google Calendar and Photos for automatic syncing.
        </p>
        {googleConnected ? (
          <>
            <IonBadge color="success">Connected</IonBadge>
            <Button
              variant="danger"
              expand="block"
              style={{ marginTop: 12 }}
              onClick={onDisconnectGoogle}
            >
              Disconnect
            </Button>
          </>
        ) : (
          <Button
            variant="primary"
            expand="block"
            iconStart={logoGoogle}
            onClick={onConnectGoogle}
          >
            Connect Google
          </Button>
        )}
      </Card>

      <Card title="Home Assistant">
        <p style={{ color: 'var(--ion-color-medium)', marginBottom: 12 }}>
          Control smart home devices from your command center.
        </p>
        {haConnected && (
          <IonBadge color="success" style={{ marginBottom: 12 }}>
            Connected
          </IonBadge>
        )}
        <div style={{ marginBottom: 16 }}>
          <TextInput
            label="Home Assistant URL"
            value={haUrl}
            onChange={onHaUrlChange}
            placeholder="http://homeassistant.local:8123"
            variant="default"
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <TextInput
            label="Access Token"
            value={haToken}
            onChange={onHaTokenChange}
            placeholder="Long-lived access token"
            type="password"
            variant="default"
          />
        </div>
        <IonNote style={{
          display: 'block',
          padding: '8px 0',
          color: 'var(--ion-color-medium)',
          fontFamily: 'var(--kff-data-font)',
          fontSize: 12,
        }}>
          Create token in HA: Profile → Long-Lived Access Tokens
        </IonNote>
        <Button
          variant="primary"
          expand="block"
          onClick={onTestAndSaveHA}
          disabled={!haUrl || !haToken || haTesting}
        >
          {haTesting ? 'Testing...' : 'Test & Save'}
        </Button>
      </Card>
    </>
  );
};

export default IntegrationsTab;
